/**
 * Cookie helper utilities for cross-subdomain data sharing
 */

export const cookieHelper = {
  /**
   * Set a cookie accessible across subdomains
   * @param {string} name - Cookie name
   * @param {string} value - Cookie value
   * @param {number} days - Expiration days (default: 30)
   * @param {string} domain - Parent domain (default: .example.com)
   */
  setCookie(name, value, days = 30, domain = null) {
    if (!domain) {
      // Extract parent domain automatically
      const parts = window.location.hostname.split('.');
      domain = parts.slice(-2).join('.');
      domain = '.' + domain;
    }

    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    const expires = `expires=${date.toUTCString()}`;
    const cookieString = `${name}=${encodeURIComponent(value)}; path=/; domain=${domain}; ${expires}`;
    document.cookie = cookieString;
  },

  /**
   * Get a cookie by name
   * @param {string} name - Cookie name
   * @returns {string|null} Cookie value or null
   */
  getCookie(name) {
    const nameEQ = name + '=';
    const cookies = document.cookie.split(';');
    for (let c of cookies) {
      c = c.trim();
      if (c.indexOf(nameEQ) === 0) {
        return decodeURIComponent(c.substring(nameEQ.length));
      }
    }
    return null;
  },

  /**
   * Delete a cookie
   * @param {string} name - Cookie name
   * @param {string} domain - Parent domain
   */
  deleteCookie(name, domain = null) {
    if (!domain) {
      const parts = window.location.hostname.split('.');
      domain = parts.slice(-2).join('.');
      domain = '.' + domain;
    }
    this.setCookie(name, '', -1, domain);
  },

  /**
   * Get all cookies as an object
   * @returns {object} All cookies as key-value pairs
   */
  getAllCookies() {
    const cookies = {};
    document.cookie.split(';').forEach(cookie => {
      const [name, value] = cookie.trim().split('=');
      if (name) cookies[name] = decodeURIComponent(value || '');
    });
    return cookies;
  }
};

export default cookieHelper;
